import React from 'react';
import { Button } from 'primereact/button';
import moment from 'moment';
import './style.css';

const CurrentDraft = ({
    currentDraft,
    selectedDraft,
    handleDraftSelect,
    deleteDraft,
    setSelectedDraft
}) => {
    if (!currentDraft) return null;

    const isSelected = selectedDraft?.id === currentDraft.id;

    return (
        <div className="current-draft-panel">
            <div className="panel-header">
                <h3>📝 Current Draft</h3>
            </div>
            <div
                className={`history-item ${isSelected ? 'selected' : ''}`}
                onClick={() => handleDraftSelect(currentDraft)}
            >
                <div className="history-item-header">
                    <div className="history-item-title">
                        <i className={`pi pi-file-edit draft-icon ${isSelected ? 'selected' : ''}`} />
                    </div>
                    <div className={`history-item-date draft-date  ${isSelected ? 'selected' : ''}`} >
                        {moment(currentDraft.updatedAt).format('MMM D, YYYY h:mm A')}
                    </div>
                </div>
                <div className="history-item-actions">
                    <Button
                        icon="pi pi-trash"
                        className={`p-button-text p-button-success delete-button ${isSelected ? 'selected' : ''}`}
                        onClick={(e) => {
                            e.stopPropagation();
                            deleteDraft();
                            setSelectedDraft(null);
                        }}
                        disabled={!isSelected}
                    />
                </div>
            </div>
        </div >
    );
};

export default CurrentDraft; 